import {compose} from 'redux';
import withCitiesAndStreets from 'common/components/hoc-helpers/withCitiesAndStreets';
import InspectionOtherPage from './InspectionOtherPage-redux';

export default compose(
  withCitiesAndStreets
)(InspectionOtherPage);
